import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  textColorGreen: {
    color: 'green',
  },
  textRedColor: {
    color: 'red',
  },
}));

export default useStyles;
